import React from 'react';
import { Cta } from './Cta';
import { Reveal } from './Reveal';
import { useScore } from './ScoreContext';
export function Hero() {
  const {
    answeredCount,
    openDiagnostic
  } = useScore();
  const ctaLabel = answeredCount === 0 ? 'Get Your Reader-to-Revenue Score' : answeredCount < 4 ? 'Continue Your Score' : 'Finish Your Score';
  const handleStartScore = () => {
    if (answeredCount === 0) {
      document.getElementById('quick-check-1')?.scrollIntoView({
        behavior: 'smooth'
      });
      return;
    }
    openDiagnostic();
  };
  return <section className="relative px-6 pt-14 pb-20 md:pt-16 md:pb-24" data-id="element-188" data-mp="x8jndoipuui9">
      <div className="relative max-w-[1040px] mx-auto" data-id="element-189" data-mp="s9q93tvluzh1">
        {/* Centered eyebrow pill */}
        <Reveal data-id="element-190" data-mp="nbop96qcuw4i">
          <div className="flex justify-center" data-id="element-191" data-mp="nbydaoruat7k">
            <span className="inline-block px-4 py-1.5 bg-white border border-black/[0.08] rounded-full text-sm text-navy/80 shadow-sm" data-id="element-192" data-mp="3d21uq4bdkwqw">
              For expert-authors whose book is already in the world
            </span>
          </div>
        </Reveal>

        {/* Centered top validation */}
        <Reveal delay={0.05} data-id="element-193" data-mp="3o859n6oa5t2g">
          <h1 className="mt-6 text-center font-serif leading-[1.1] tracking-[-0.01em] text-[clamp(2.1rem,4vw,3.25rem)]" data-id="element-194" data-mp="3o6aru18b2h2l">
            <span className="block text-seaglass" data-id="element-195" data-mp="39cflb1vmh3uk">
              Your book did what a book can do.
            </span>
            <span className="block text-navy italic" data-id="element-196" data-mp="3eb8xmqz6aot5">
              It created authority.
            </span>
          </h1>
        </Reveal>

        {/* Lower tension composition: question left, artwork anchored to the hero's right edge */}
        <Reveal delay={0.1} data-id="element-197" data-mp="2qkwjgydc3vu4">
          <div className="mt-11 grid grid-cols-1 items-center gap-7 lg:mt-14 lg:grid-cols-[440px_1fr] lg:gap-x-12" data-id="element-198" data-mp="2qlofuber9xlg">
            <div className="order-1 lg:translate-x-16" data-id="element-199" data-mp="2vgtwovtawm2o">
              <h2 className="font-serif text-sand-dark leading-[0.94] tracking-[-0.018em] text-center text-[clamp(2rem,8vw,2.75rem)] lg:text-[clamp(2.35rem,4.2vw,3.5rem)]" data-id="element-200" data-mp="2hk85u4rurxhr">
                <span className="block lg:whitespace-nowrap" data-id="element-201" data-mp="s2jnhxye22k1">
                  But did it lead
                </span>
                <span className="block lg:whitespace-nowrap" data-id="element-202" data-mp="naa0aponrglg">
                  to the opportunities
                </span>
                <span className="block lg:whitespace-nowrap" data-id="element-203" data-mp="icrmolzp4d74">
                  you expected?
                </span>
              </h2>
            </div>

            <div className="order-2 flex justify-center lg:justify-end" data-id="element-204" data-mp="1b1ffr3qos6v8">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4wv71qfbbbwbngbvre9mbk/67ed1325-767e-4f35-bd1c-b49fa7a310ff/Untitled_design_(6).png" alt="An open book whose pages flow into a winding sea-glass path toward a warmly glowing doorway — the path from a book to real opportunities." className="h-auto w-full max-w-[390px] object-contain lg:w-[480px] lg:max-w-none" loading="eager" data-id="element-205" data-mp="1ayjh1d70le5q" />
              
            </div>
          </div>
        </Reveal>

        {/* Centered short body copy */}
        <Reveal delay={0.15} data-id="element-206" data-mp="1x9ukuaytndnf">
          <div className="mt-9 md:mt-10 max-w-[620px] mx-auto text-center" data-id="element-207" data-mp="1xam9t2xwyd4q">
            <p className="text-navy font-semibold text-lg mb-2" data-id="element-208" data-mp="21a4ubxltom71">
              Most readers disappear after the book.
            </p>
            <p className="text-lg text-text-muted leading-relaxed" data-id="element-209" data-mp="268oebsguvnwr">
              You do not know who cared, what landed, what they needed next, or
              whether they were a fit for the work behind the book.
            </p>

            {/* Centered CTA */}
            <div className="mt-8 flex flex-col items-center" data-id="element-210" data-mp="2ky40sw9ct76n">
              <Cta variant="primary" onClick={handleStartScore} className="min-h-[56px] px-8 py-4 font-semibold text-lg opacity-100 w-full sm:w-auto" data-id="element-211" data-mp="2p0h83p3r1d5j">
                
                {ctaLabel}
              </Cta>
              <p className="mt-4 text-sm text-navy/80 font-medium" data-id="element-212" data-mp="umpsm8yqnz26">
                8 questions. See what happens after someone reads your book.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}